export default __webpack_public_path__ + "static/media/nubMaduroOpen.c6a581f8.png";